import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ConsentContent = styled(Box)(({ theme }) => ({
  "& p": {
    marginBottom: theme.spacing(1.5),
  },
  "& strong": {
    fontWeight: 600,
  },
  "& ul, & ol": {
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(1.5),
  },
}));

export const ConsentDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    maxWidth: 640,
  },
});

export const ConsentDialogTitle = styled(DialogTitle)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontWeight: 600,
}));

export const ConsentDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  gap: theme.spacing(1),
}));

export { Button, DialogContent };
